// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "3dbccb2b" + "." + "16e89c5b066c56fb" + ".js";
};